import { i18n } from "@/i18n/i18n";
import { licensePlateRegex } from "../constants";

const utf8Regex = /^[a-zA-Z\u00C0-\u017F!.$\d-]+$/;
const utf8RegexConfirmPassword = /^[\s\S]+$/;

export interface ValidationRule {
  maxLength?: number;
  minLength?: number;
  regex?: RegExp;
  message: string;
  required?: boolean;
}

export interface ValidationRulesInterface {
  username: ValidationRule;
  first_name: ValidationRule;
  last_name: ValidationRule;
  phone_number: ValidationRule;
  license_plate: ValidationRule;
  qualification: ValidationRule;
  current_password: ValidationRule;
  password: ValidationRule;
  password_confirmation: ValidationRule;
  user_id?: ValidationRule;
}

const validationRules: ValidationRulesInterface = {
  username: {
    maxLength: 255,
    minLength: 4,
    regex: utf8Regex,
    message: i18n.global.t("driver.validation.username"),
    required: true,
  },
  first_name: {
    maxLength: 255,
    regex: utf8Regex,
    message: i18n.global.t("driver.validation.first_name"),
  },
  last_name: {
    maxLength: 255,
    regex: utf8Regex,
    message: i18n.global.t("driver.validation.last_name"),
  },
  phone_number: {
    maxLength: 15,
    regex: /^[0-9+\-/]+$/,
    message: i18n.global.t("driver.validation.phone_number"),
    required: true,
  },
  license_plate: {
    maxLength: 64,
    regex: licensePlateRegex,
    message: i18n.global.t("driver.validation.license_plate"),
  },
  qualification: {
    maxLength: 255,
    // eslint-disable-next-line no-useless-escape
    regex: utf8Regex,
    message: i18n.global.t("driver.validation.qualification"),
  },
  current_password: {
    minLength: 1,
    regex: utf8RegexConfirmPassword,
    message: i18n.global.t("driver.validation.current_password"),
    required: true,
  },
  password: {
    minLength: 8,
    regex: new RegExp(
      // eslint-disable-next-line no-useless-escape
      /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?& . #'+\/=*^_`{|}~"§°(),;:<>€-])[A-Za-z\d@$!%*?& . #'+\/=*^_`{|}~"§°(),;:<>€-]+$/
    ),
    message: i18n.global.t("driver.validation.password"),
    required: true,
  },
  password_confirmation: {
    minLength: 8,
    message: i18n.global.t("driver.validation.password"),
    required: true,
  },
};

export default validationRules;
